import {assert} from 'assert-ts';
import type {Prize} from 'services/prizes/types';
import {isPrizeValue} from './isPrizeValue';

export const assertPrizeValue = (value: unknown): Prize => {
  assert(isPrizeValue(value), 'assertPrizeValue: invalid prize', {value});

  return value as Prize;
};
